export default __webpack_public_path__ + "static/media/404_bg_mobile.1eadbb0a.png";